import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, BUTTON_TYPES, Card } from '_atoms';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms/Typography';
import { ROUTES } from 'router/constants';
import './style.scss';

export const AccessDenied = () => {
  const { t } = useTranslation();
  return (
    <div className="page-access-denied">
      <Card className="page-access-denied__card">
        <div className="info">
          <Typography.Title3 weight={TYPOGRAPHY_WEIGHT.BOLD}>{t('translation:access_denied.title')}</Typography.Title3>
          <Typography.Text>{t('translation:access_denied.text_no_permission')}</Typography.Text>
          <Link to={ROUTES.DASHBOARD}>
            <Button type={BUTTON_TYPES.PRIMARY}>{t('translation:access_denied.button_go_to_dashboard')}</Button>
          </Link>
        </div>
      </Card>
    </div>
  );
};
